import { logger } from '@myrealtrip/nextjs';
import { useQuery } from '@tanstack/react-query';

import { memberApi } from '~endpoints/Member';
import { memberKeys } from '~queryKeys/memberKeys';
import { RequestParams } from '~utils/https/HttpClientFetch';

export async function fetchMembers(params: RequestParams = {}) {
  try {
    return (await memberApi.v1.members(params)) || null;
  } catch (error) {
    logger.error(error);
    return null;
  }
}

export function useMember() {
  return useQuery({
    queryKey: memberKeys.members(),
    queryFn: () => memberApi.v1.members(),
    select: (response) => {
      const { data } = response ?? {};
      const { userInfo } = data ?? {};
      const { id, name, email, phone, point, activeCouponCodeCount, profileImage } = userInfo ?? {};

      return {
        id,
        name,
        emailAddress: email?.address ?? '',
        phoneNumber: phone?.number ?? '',
        point,
        activeCouponCodeCount,
        profileImageUrl: profileImage?.url ?? '',
      };
    },
  });
}
